export default {"src":"/_next/static/media/chevron-right.0b784161.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};